import React from 'react';
import HomeFloorBox from './home-floor-box';
import MoreBtn from './home-floor-more-btn';
import KeralaCard from './kerala.card';
import {KeralaListItem} from '@/pages/home/home.type';

interface HomeFloorKeralaProps {
  name: string;
  id: string;
  shown?: boolean;
  isHome?: boolean;
  serverTime?: number;
  categoryPic?: string;
  keralaList: KeralaListItem[];
}

const isClosed = (item: KeralaListItem, serverTime: number) => {
  const seconds = item.drawDate - serverTime;
  if (seconds <= 0) {
    return true;
  }
  return false;
};

const HomeFloorKerala = ({
  name,
  keralaList = [],
  categoryPic,
  id,
  shown = true,
  serverTime = 0,
}: HomeFloorKeralaProps) => {
  const [more, setMore] = React.useState(false);

  return (
    <HomeFloorBox
      gameType={'kerala'}
      id={id}
      shown={shown}
      name={name}
      rightNode={<MoreBtn expend={more} onClick={() => setMore(!more)} />}
      categoryPic={categoryPic}>
      <>
        {(more ? keralaList : keralaList.slice(0, 6)).map((item, _i) => (
          <KeralaCard
            isClosed={isClosed(item, serverTime)}
            isHome={false}
            key={_i}
            i={_i}
            v={item}
          />
        ))}
      </>
    </HomeFloorBox>
  );
};

export default HomeFloorKerala;
